// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'general-ledger-account.page.form.title': 'Advanced',

    'general-ledger-account.page.title': 'Chart of Accounts',
    'general-ledger-account.page.archive.title': 'Archived Accounts',
    'general-ledger-account.page.search_results': 'Search Results',
    'general-ledger-account.page.create.title': 'Create New Account',
    'general-ledger-account.page.search.title': 'Find Accounts',
    'general-ledger-account.page.edit.title': 'Edit Account',
    'general-ledger-account.page.all': 'All',

    'general-ledger-account.button.cancel': 'Cancel',
    'general-ledger-account.button.select': 'Select',
    'general-ledger-account.button.find': 'Find Accounts',
    'general-ledger-account.button.search': 'Apply',
    'general-ledger-account.button.create': 'Save Account',
    'general-ledger-account.button.new': 'New Account',
    'general-ledger-account.button.save': 'Save Changes',
    'general-ledger-account.button.archive': 'Archive',
    'general-ledger-account.button.delete': 'Permanently Delete',
    'general-ledger-account.button.edit': 'Edit',
    'general-ledger-account.button.restore': 'Restore',
    'general-ledger-account.button.reset': 'Reset',

    'general-ledger-account.placeholder.search': 'Search accounts',

    'general-ledger-account.link.create_first_general_ledger_account': 'Click here to create your first account',
    'general-ledger-account.link.general_ledger_accounts': ' Return to Accounts',
    'general-ledger-account.link.archive': 'Archived Accounts',
    'general-ledger-account.link.retry': 'Click here to retry',

    'general-ledger-account.checkbox.all': 'Check All',
    'general-ledger-account.checkbox.actions_label': 'with selected',

    'general-ledger-account.label.parent_general_ledger_account_name': 'Parent Account',
    'general-ledger-account.label.is_parent_account': 'Is Parent Account?',
    'general-ledger-account.label.general_ledger_account_type_name': 'Account Type',
    'general-ledger-account.label.general_ledger_account_category_name': 'Account Category',
    'general-ledger-account.label.general_ledger_account_jurisdiction_classification_name': 'Account Jurisdiction Classification',
    'general-ledger-account.label.general_ledger_account_no': 'Account No',
    'general-ledger-account.label.general_ledger_account_name': 'Account Name',
    'general-ledger-account.label.is_non_cash_account': 'Is Non Cash Account',

    'general-ledger-account.label.currency_name': 'Currency',

    'general-ledger-account.label.reporting_segment_name': 'Reporting Segment',
    'general-ledger-account.label.income_statement_classification_name': 'Income Statement Classification',
    'general-ledger-account.label.cash_flow_statement_classification_name': 'Cash Flow Statement Classification',
    'general-ledger-account.label.statement_of_position_classification_name': 'Statement Of Position Classification',

    'general-ledger-account.label.reference_type': 'Reference Type',
    'general-ledger-account.label.general_ledger_account_description': 'Account Description',
    'general-ledger-account.label.is_system_account': 'Is System Account',
    'general-ledger-account.label.is_visible': 'Is Visible',

    'general-ledger-account.sort.field_label': 'Field',
    'general-ledger-account.sort.direction_label': 'Direction',
    'general-ledger-account.sort.direction_ascending': 'Ascending',
    'general-ledger-account.sort.direction_descending': 'Descending',

    'general-ledger-account.modal.title.general_ledger_account_archive': 'Archive Account',
    'general-ledger-account.modal.title.general_ledger_account_delete_permanently': 'Delete Account',
    'general-ledger-account.modal.title.general_ledger_account_restore': 'Restore Account',

    'general-ledger-account.modal.message.general_ledger_account_archive': 'Are you sure that you want to move this account to the archive? | Are you sure that you want to move these accounts to the archive?',
    'general-ledger-account.modal.message.general_ledger_account_delete_permanently':
        'Are you sure that you want to permanently delete this account? This action cannot be undone. | Are you sure that you want to permanently delete these accounts? This action cannot be undone.',
    'general-ledger-account.modal.message.general_ledger_account_restore': 'Are you sure that you want to restore this account? | Are you sure that you want to restore these accounts?',

    'general-ledger-account.success.message.general_ledger_account_created': 'Your account has been created',
    'general-ledger-account.success.message.general_ledger_account_updated': 'Your account has been updated',
    'general-ledger-account.success.message.general_ledger_account_restored': 'Your account has been restored | All selected accounts were restored',
    'general-ledger-account.success.message.general_ledger_account_deleted': 'Your account has been permanently deleted | All selected accounts were permanently deleted',
    'general-ledger-account.success.message.archived_general_ledger_accounts': 'Your account was moved to the archive | All selected accounts were moved to the archive',

    'general-ledger-account.error.message.archived_general_ledger_accounts': 'This account was already moved to the archive | These accounts were already moved to the archive',
    'general-ledger-account.error.message.general_ledger_account_deleted': 'This account was already permanently deleted | These accounts were already permanently deleted',
    'general-ledger-account.error.message.general_ledger_account_restored': 'This account was already restored | These accounts were already restored',
    'general-ledger-account.error.message.error_loading_page': 'Sorry, there was an error loading account.| Sorry, there was an error loading accounts.',

    'general-ledger-account.message.search.no_archived_general_ledger_accounts': "You haven't archived any general any ledger any accounts as yet.",

    'general-ledger-account.label.dimension_requirements': 'Dimension Requirements',
    'general-ledger-account.label.dimension_required': 'Required',
    'general-ledger-account.label.dimension_mandatory': 'Mandatory',
    'general-ledger-account.label.no_dimensions_configured': 'No dimension requirements configured',
};
